import React from "react";

import "../../css/sismo_sentido.css";

export default function MensajeValidacion ({errors, nombre}) {    
    if (errors && errors[nombre]) {        
        return <div className="MensajeError"><span style={{color:"#f00"}}>*</span> Campo requerido</div>
    } else {        
        return null;
    }
}